import { Pipe, PipeTransform } from '@angular/core';
import { UsersService } from '@services/api/administracja/user-access/users.service';

@Pipe({
  name: 'hasPermission',
})
export class HasPermissionPipe implements PipeTransform {
  constructor(private readonly permissionsService: UsersService) {}
  transform(permissionCode: string): boolean {
    let hasPermission: boolean;
    this.permissionsService.doesUserHavePermission(permissionCode).subscribe((v) => {
      hasPermission = v;
    });
    return hasPermission;
  }
}
